export default __webpack_public_path__ + "static/resolu-entete-offre-5398a2e17a2f623b0ed05299fed86808.png";